module.exports = __webpack_public_path__ + "img/thumb.0619bf65.jpg";